import { render } from "./GivingForm2.vue?vue&type=template&id=36faffda&scoped=true"
import script from "./GivingForm2.vue?vue&type=script&lang=js"
export * from "./GivingForm2.vue?vue&type=script&lang=js"

import "./GivingForm2.vue?vue&type=style&index=0&id=36faffda&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36faffda"]])

export default __exports__